import { useMemo } from 'react'
import { rankForViewer } from '@shared/ranking'
import { useEventArtistMatches } from '../../hooks/useEventArtistMatches'
import { useFrozenValue } from '../../hooks/useFrozenValue'
import type { Event } from '../../types'

/** How many events For you shows. */
export const FOR_YOU_COUNT = 5

/**
 * The near-you events ranked for this viewer: global score plus followed
 * artists on the lineup. Frozen like the rest of Home, but only once the
 * artist matches are in — freezing earlier would lock in the unboosted order,
 * and showing it live would reshuffle the cards when the search index lands.
 * `personalized` is false for guests and for users who follow no artists, who
 * get the plain global ranking ("Popular near you").
 */
export function useForYou(nearPool: Event[], userId: string | null, contentReady: boolean, resetKey: string) {
  const { matches, followsArtists, ready } = useEventArtistMatches(userId)
  const live = useMemo(
    () => rankForViewer(nearPool, matches).slice(0, FOR_YOU_COUNT),
    [nearPool, matches],
  )
  const allReady = contentReady && ready
  const events = useFrozenValue(live, allReady, resetKey)
  return { events, personalized: followsArtists, loading: !allReady }
}
